module.exports = __webpack_public_path__ + "media/flags/ni-c9e542cd.svg";